export class Header {
    constructor() {
        this.header = document.querySelector('header');

        // this.header2 = this.header.cloneNode(true);
        // this.header2.classList.remove('header');
        // this.header2.classList.add('header2');
        // // this.header2.querySelector('.header_lang_switch').remove();
        // this.header.after(this.header2);    


        // this._onScroll = this._onScroll.bind(this);
        
        // window.addEventListener('scroll', this._onScroll);
       

    }


    _onScroll() {

        if ((window.scrollY - this.lastKnownScrollPosition) > 0) {
    
          this.header2.classList.remove('is-active');
    
    
        } else {
          if (window.scrollY > this.header.offsetHeight) {
            this.header2.classList.add('is-active');
          } else {
            this.header2.classList.remove('is-active');
          }
        }
        this.lastKnownScrollPosition = window.scrollY;
      }
    
    
}
new Header ();